<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title">EXTREME<br/>CROCHET<br/><span class="title1">WITH CHUNKY YARN</span></h1>
<h2 class="description">8 QUICK CROCHET PROJECTS FOR HOME &amp; ACCESSORIES</h2>
<h2 class="author">SARAH SHRIMPTON</h2>
<p class="logo"><img alt="" src="images/logo.gif"/></p>
<p class="publisher"><a href="http://www.stitchcraftcreate.co.uk" target="_blank">www.stitchcraftcreate.co.uk</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title.vue?63a2e4d4